import { gql } from '@apollo/client';

export const getProductDetailsQuery = properties => gql`
  query getProduct($id: String!) {
    product: getPublishedProduct(id: $id) {
      id
      ${formatProperties(properties)}
    }
  }
`;

const formatProperties = properties => {
  const { brandProperty, categoryProperties = [], itemNameProperty } = properties;

  return [
    itemNameProperty,
    formatProperty(brandProperty),
    ...categoryProperties.map(formatProperty)
  ]
    .filter(Boolean)
    .join(`\n`);
};

const formatProperty = (property, prefix) => {
  if (!property) return '';

  if (!property.includes('.')) return property;

  const [parentProperty, childProperty] = property.split('.');
  return `${parentProperty} { id, ${childProperty} }\n      `;
};
